import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import pipelineService from '../../api/pipelineService'

const initialState = {
  pipelines: [],
  isLoading: false,
  isError: false,
  isSuccess: false,
  message: '',
}

// Fetch pipeline details
export const fetchPipelines = createAsyncThunk(
  'pipelines/fetchAll',
  async (databaseName, thunkAPI) => {
    try {
      return await pipelineService.getPipelines(databaseName)
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.message) ||
        error.message ||
        error.toString()
      return thunkAPI.rejectWithValue(message)
    }
  }
)

const pipelineSlice = createSlice({
  name: 'pipelines',
  initialState,
  reducers: {
    reset: (state) => {
      state.isLoading = false
      state.isError = false
      state.isSuccess = false
      state.message = ''
    },
    clearPipelines: (state) => {
      state.pipelines = []
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPipelines.pending, (state) => {
        state.isLoading = true
      })
      .addCase(fetchPipelines.fulfilled, (state, action) => {
        state.isLoading = false
        state.isSuccess = true
        state.pipelines = action.payload
      })
      .addCase(fetchPipelines.rejected, (state, action) => {
        state.isLoading = false
        state.isError = true
        state.message = action.payload
      })
  },
})

export const { reset, clearPipelines } = pipelineSlice.actions
export default pipelineSlice.reducer
